@if (!$host().laneColumnHasItems($swimlane(), $column().key)) {
  <div class="kanban-item-empty">
    {{ $host().emptyMessage() }}
  </div>
}

@for (item of $column().items; track $host().trackItem(item, $index); let i = $index) {
  <!-- Gestures, not raw click/dblclick: an iPad has no double click it can reach, so a long press
       opens the record the way a double click does on a mouse. -->
  <div class="kanban-item" wbPointerGestures (tap)="$host().onItemTapped(item)" (doubleTap)="$host().onItemDblClicked({ item, isSwimlaneItem: false })" (longPress)="$host().onItemDblClicked({ item, isSwimlaneItem: false })" [class.active]="$host().isSelected(item, $host().selectedItem())">
    @if ($host().itemTemplate(); as itemTemplate) {
      <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ item, index: i, utility: $host().colorUtility }" />
    }
  </div>
}
